import googleDrive from '../../Actions/googleDrive';
const { types } = googleDrive;

const initialState = {
    data: {
        name: '',
        email: '',
        image: ''
    },
    tabSelected: '1'
};

const googleDriveReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_GOOGLE_DATA:
			return {
				...state,
                data: action.data,
            };
        case types.SELECT_TAB:
            return {
				...state,
                tabSelected: action.tab,
            };
        default:
            return state;
    }
}

export default googleDriveReducer;